<template>
  <div>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <router-link :to="{ name: 'Home' }">Zurück zur Hauptseite</router-link>
  </div>
</template>